import React from "react";
import { siteData } from "../mock";

const WavyLines = () => (
  <svg
    className="hero-waves"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    {Array.from({ length: 11 }).map((_, i) => {
      const y = 120 + i * 34;
      const d = `M-20 ${y} C 150 ${y - 24}, 320 ${y + 26}, 480 ${y - 10} S 780 ${y + 22}, 920 ${y - 4}`;
      return (
        <path
          key={i}
          d={d}
          fill="none"
          stroke="#ffffff"
          strokeOpacity={0.8}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      );
    })}
  </svg>
);

const ArrowDown = () => (
  <svg width="22" height="46" viewBox="0 0 22 46" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M11 2 C 10 14, 12 26, 11 40" stroke="#A33B35" strokeWidth="1.2" fill="none" strokeLinecap="round" />
    <path d="M5 34 L 11 42 L 17 34" stroke="#A33B35" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Hero = () => {
  return (
    <section id="top" className="hero">
      <WavyLines />
      <div className="hero-inner">
        <div className="hero-image-wrap">
          <div className="hero-circle">
            <img src={siteData.images.hero} alt="Séance de Shiatsu" className="hero-image" />
          </div>
        </div>
        <div className="hero-content">
          <p className="hero-eyebrow">Le Shiatsu libère ce que le corps retient</p>
          <h1 className="hero-title">
            Détente <span className="dash">—</span> Bien-être <span className="dash">—</span> Rééquilibrage énergétique
          </h1>
          <a href="#le-shiatsu" className="hero-link">
            <span>EN SAVOIR PLUS</span>
            <ArrowDown />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
